import { Box } from "@mui/material";
import classNames from "classnames";
import React from "react";
import { makeStyles } from '@mui/styles';
import { portalCfg } from "../config";

const lab4BGImage = portalCfg.publicPath+ "/images/lab4_background.jpg"

const useStyles = makeStyles(() => ({
    main: {
      backgroundImage: `url(${lab4BGImage})`,
      backgroundSize: 'cover',        
      backgroundPosition: 'center',    
      backgroundRepeat: 'no-repeat',   
      minHeight: '100%',              
      width: '100%',                  
    },
  }));
  

export default function Container(props) {
    const { children } = props;

    const classes = useStyles();

    return (
        <Box className={classNames(classes.main)}>
            {children}
        </Box>
    )
}